import { formatter } from "@engage/i18n/format";
import { joinMessages } from "@engage/i18n/join";
import { createContext } from "preact";
import { useContext } from "preact/hooks";

export type I18n = ReturnType<typeof formatter> & { locale: string };

/** The phone's languages first, then the organisation's default. */
export function createI18n(orgDefault?: string | null): I18n {
  const { locale, messages } = joinMessages(navigator.languages?.join(",") ?? navigator.language, orgDefault);
  document.documentElement.lang = locale;
  return { locale, ...formatter(locale, messages) };
}

export const I18nContext = createContext<I18n>(null as unknown as I18n);
export const useI18n = () => useContext(I18nContext);
